import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=3ef5b492&scoped=true&"
import script from "./cookie-policy.vue?vue&type=script&lang=js&"
export * from "./cookie-policy.vue?vue&type=script&lang=js&"
import style0 from "./cookie-policy.vue?vue&type=style&index=0&id=3ef5b492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5b492",
  null
  
)

export default component.exports